// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS rules from the original FontAwesomeIcon component */
svg:not(:root).svg-inline--fa,
svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: inline-block;
  overflow: visible;
  vertical-align: -0.125em;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/AwesomeIcon/AwesomeIcon.scss"],"names":[],"mappings":"AAAA,0DAAA;AACA;;EAEE,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;EACA,iBAAA;EACA,wBAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
